var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[((_vm.userType===1))?_c('img',{staticClass:"top-img",attrs:{"src":require("./../../images/top.png"),"alt":""}}):_c('img',{staticClass:"top-img",attrs:{"src":require("./../../images/no-top.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }